import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const bookingConfigAPI = axios.create({
  baseURL: `${API_BASE_URL}/booking-config`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const bookingConfigService = {
  getConfig: async () => {
    const response = await bookingConfigAPI.get('/');
    return response.data;
  },
};

export default bookingConfigService;
